import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { take, finalize, tap, map, switchMap, mapTo } from 'rxjs/operators';
import { Course, enrollment } from "../../../app/courses/core/model/course";

import { Store } from '@ngrx/store';
import { ActionSettingsChangeTheme } from '../../settings';
import { Observable, combineLatest, of } from 'rxjs'
import { uniq, flatten } from 'lodash'

import * as firebase from 'firebase/app';
import { xUserBase } from '@area/user/lib/core/xuser.model';



export interface avatar {
  name: string,
  description: string,
  photo: string
}
@Injectable()
export class ConfigService {
  urlInstitucion: any;
  nameInstitucion: any;
  EnrollCollection: AngularFirestoreCollection<enrollment>;
  joined$: Observable<any>



  constructor(public afs: AngularFirestore, private store: Store<any>) { }


  getConfig() {
    const data = this.afs.collection('config').doc('contacts').valueChanges();
    return data
  }

  public getAvatars() {
    const data = this.afs.collection('config').doc<avatar[]>('avatars').valueChanges().pipe(
      map(data => data["payload"])
    );
    return data
  }

	/**
	 * ChangeTheme
	 */
  public changeTheme(theme) {
    // this.store.dispatch(new ActionSettingsChangeTheme(theme));
  }

  public checkSchool() {
    let response = {};
    this.urlInstitucion = window.location.origin;
    //console.log(this.urlInstitucion);
    if (this.urlInstitucion == 'http://localhost:5500' || this.urlInstitucion.includes('istmo')) {
      this.nameInstitucion = 'istmo';
    } else if (this.urlInstitucion == 'http://localhost:4200' || this.urlInstitucion.includes('moocs-4355c') || this.urlInstitucion.includes('233515') || this.urlInstitucion.includes('andina') || this.urlInstitucion.includes(8089) || this.urlInstitucion.includes('arenadina')) {
      this.nameInstitucion = 'areandina';
    } else if (this.urlInstitucion == 'http://localhost:5000' || this.urlInstitucion.includes('sanmarcos')) {
      this.nameInstitucion = 'sanmarcos';
    }
    response = ({ name: this.nameInstitucion, url: this.urlInstitucion });
    return response;
  }
  public getSchoolInfo(name: string) {
    return this.afs.collection('institucion').doc('' + name + '').valueChanges().pipe(take(1));
  }
  public getUsers() {

    return this.afs.collection('users').valueChanges().pipe(take(1));

  }

  public getEnrollments() {

    return this.afs.collection('enrollment').valueChanges().pipe(take(1));

  }

  public getReport() {
    const allData = [];
    //, ref => ref.orderBy('uid').startAt('b8qmBdGManeNYfjhBdJwViVuZNP2')
    return this.afs.collection('users').valueChanges()
      .pipe(take(1),
        switchMap(resUser => {
          const dataUser = uniq(resUser.map(res => res))
          /* 			const userId = uniq(resUser.map(res => res['uid'])) */
          return combineLatest(
            of(resUser),
            combineLatest(
              dataUser.map(dataUser =>
                this.afs.collection('enrollment', ref => ref.where('idUser', '==', dataUser['uid'])).valueChanges().pipe(
                  map(enrollment => {
                    enrollment.map(res => {
                      allData.push({
                        iduser: dataUser['uid'],
                        nombre: dataUser['displayName'],
                        correo: dataUser['email'],
                        ID: dataUser['identification'],
                        nameCurso: res['courseName'],
                        progress: res['progress']
                      })
                      console.log(allData.length)
                    })
                  })

                )
              )
            )
          )
        }),
        map(([resUser]) => {
          return allData
        })
      )
  }

  public getUser(id) {
    console.log(id)
    return this.afs.collection('users').doc('' + id + '').valueChanges().pipe(take(1));
  }

  UpdateUser(uid: string, Duser: Partial<xUserBase>) {

    const _data = this.afs.collection("users").doc<xUserBase>(uid).update(Duser);
    return _data
  }

  getFullUser(uid) {
    // console.log(uid)
    return this.afs.collection('users_extra').doc('' + uid + '').valueChanges();


    // let users = this.afs.collection('users');
    // let extraUser = this.afs.collection('users_extra');

    /*     return users.get().pipe(map(res => {
          const uid = res;
          return combineLatest(
            of(res),
            combineLatest(
              this.afs.collection('users_extra').doc('' + uid['uid'] + '').valueChanges().pipe(
                map(extrainfo => {
                  console.log(extrainfo)
                  console.log(uid)
                  data.push({
                    user: uid,
                    extra: extrainfo
                  })
                }))
            )

          )
        })
        ),mapTo (([res])=>{
          return data
        })
     */
  }

  UpdateUserExtra(uid, data) {
    return this.afs.collection('users_extra').doc(uid).set(data)
  }



  deleteFields() {

    return this.afs.collection("users", ref => ref.where("gender", "==", "")).valueChanges().pipe(take(1)).subscribe(res => {
      //console.log("res in service")
      res.map((item, index, array) => {
        // console.log(item)
        let prueba = this.afs.collection('users').doc(item['uid']);
        let fieldRm = prueba.update({
          gender: firebase.firestore.FieldValue.delete(),
          organizacion: firebase.firestore.FieldValue.delete()
        })
      })
    })



  }
}
